// Build trigger: force a dev FE rebuild (path-scoped Ignored Build Step skips
// commits that don't touch frontend/). Safe to remove.
import React from 'react';
import { createRoot } from 'react-dom/client';
import { FluentProvider } from '@fluentui/react-components';
import { twmLightTheme } from './contexts/ThemeContext';
import './styles/index.css';

import App from './App';
import { initApiBase } from './config/api';

const root = createRoot(document.getElementById('root'));

// On preview deployments, resolve the matching backend preview before first
// render so every request targets it. Instant no-op on prod and local dev.
// Outer provider uses twmLightTheme so first paint matches the in-app font.
initApiBase().finally(() => {
  root.render(
    <FluentProvider theme={twmLightTheme}>
      <App />
    </FluentProvider>,
  );
});
